"use client";
import { Modal } from "@mui/material";

import { apiCallsModalStore } from "./modalStore";
import { ApiCallsAutoSearchSuccessModal } from "./Modals/AutoSearch/Success";
import { ApiCallsAutoSearchErrorModal } from "./Modals/AutoSearch/Error";
import { useSearchParams } from "next/navigation";
import { PROCESS_INSTANCE_QUERY } from "@/src/shared/const";
import { useFormContext } from "react-hook-form";
import { getContextVariablesToUpdate } from "./utils";
import { ApiCallModalType } from "./types";
import { ApiCallsLoadingModal } from "./Modals/Loading";
import { ApiCallsFinMonErrorModal } from "./Modals/FinMon/Error";
import { OTPModal } from "./Modals/OtpModal";
import { ErrorModal } from "./Modals/ErrorModal";
import { InfoModal } from "./Modals/InfoModal";
import { AgreementModal } from "./Modals/AgreementModal";
import { useSpecificStepNavigation } from "@/src/components/Action/useNavigation";
import { ApiCallsAutoSearchForbiddenModal } from "./Modals/AutoSearch/ForbiddenModal";
import { useTimeSpentStore } from "@/src/stores/useTimeSpentStore";

export const ApicallsModal = () => {
  const { modal, close } = apiCallsModalStore();
  const { mutateAsync } = useSpecificStepNavigation();
  const searchParams = useSearchParams();
  const { getTimeSpent } = useTimeSpentStore();

  const {
    getValues,
    formState: { dirtyFields },
  } = useFormContext();
  const processInstanceId = searchParams.get(PROCESS_INSTANCE_QUERY);

  if (!modal || !processInstanceId) {
    return null;
  }

  const goToStep = async (stepId: string | undefined) => {
    if (
      (modal.type !== ApiCallModalType.AUTO_SEARCH_ERROR &&
        modal.type !== ApiCallModalType.AUTO_SEARCH_FORBIDDEN &&
        modal.type !== ApiCallModalType.AUTO_SEARCH_SUCCESS) ||
      !stepId
    )
      return;
    await mutateAsync({
      code: stepId,
      body: {
        processInstanceId,
        contextVariablesToUpdate: getContextVariablesToUpdate(
          getValues(),
          dirtyFields,
          true,
        ),
        timeSpent: getTimeSpent(),
        navigationType: "NEXT",
      },
    });
    close();
  };

  return (
    <>
      <Modal
        open={true}
        onClose={() => {
          if (modal.type === ApiCallModalType.LOADING) {
            if (!modal.data?.disableClose) {
              close();
              return;
            }
            return;
          }
          close();
        }}
      >
        <>
          {modal.type === ApiCallModalType.AUTO_SEARCH_SUCCESS && (
            <ApiCallsAutoSearchSuccessModal
              onClose={() => {
                goToStep(modal?.data?.cancelStepId);
              }}
              onSubmit={() => goToStep(modal?.data?.submitStepId)}
              {...modal.data}
            />
          )}
          {modal.type === ApiCallModalType.AUTO_SEARCH_ERROR && (
            <ApiCallsAutoSearchErrorModal
              onClose={close}
              onSubmit={() => goToStep(modal?.data?.stepId)}
              {...modal.data}
            />
          )}
          {modal.type === ApiCallModalType.AUTO_SEARCH_FORBIDDEN && (
            <ApiCallsAutoSearchForbiddenModal onClose={close} {...modal.data} />
          )}
          {modal.type === ApiCallModalType.OTP && <OTPModal {...modal.data} />}
          {modal.type === ApiCallModalType.ERROR && (
            <ErrorModal {...modal.data} />
          )}
          {modal.type === ApiCallModalType.INFO && (
            <InfoModal {...modal.data} />
          )}
          {modal.type === ApiCallModalType.AGREEMENT && (
            <AgreementModal {...modal.data} />
          )}
          {modal.type === ApiCallModalType.FINMON_ERROR && (
            <ApiCallsFinMonErrorModal {...modal.data} />
          )}

          {modal.type === ApiCallModalType.LOADING && (
            <ApiCallsLoadingModal
              title={modal.data?.title}
              description={modal.data?.description}
              disableClose={modal.data?.disableClose}
            />
          )}
        </>
      </Modal>
    </>
  );
};
